/**
 * Pressure Performance: basic attribution plumbing (no affiliate app).
 * Captures ?fighter= and/or ?code= and stores onto cart attributes via /cart/update.js
 * so orders can be reconciled later for revenue share.
 */

(() => {
  const params = new URLSearchParams(window.location.search);
  const fighter = (params.get('fighter') || '').trim();
  const code = (params.get('code') || '').trim();

  if (!fighter && !code) return;

  try {
    if (fighter) localStorage.setItem('pp_fighter', fighter);
    if (code) localStorage.setItem('pp_code', code);
  } catch (e) {
    // ignore
  }

  const attributes = {};
  if (fighter) attributes.pp_fighter = fighter;
  if (code) attributes.pp_code = code;

  fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ attributes }),
  }).catch(() => {});
})();


